import {IUserStatistic} from '@/stores/ItemsStore/ItemsStore.types';

import {formatNumberSum} from '@specials/utils';

import {MIN_HUGE_VALUE} from '@/constants';
import {SignsAfterCommaValidationRule, StatisticValidationRule} from '@/resources';
import {FrontendError} from '@/services/ErrorService/FrontendError';
import {StatisticItemValidationType} from '@/types';
import {ValidationUtils} from '@/utils/ValidationUtils';

export const validateSignsAfterCommaInNumber = (
  statistic: IUserStatistic,
  rule: StatisticValidationRule,
  logError: (error: FrontendError) => void,
  shouldLogError = true,
): string | null => {
  if (
    !ValidationUtils.isValidationRule<SignsAfterCommaValidationRule>(rule, StatisticItemValidationType.SignsAfterComma)
  ) {
    return null;
  }

  let statisticValue = statistic.value;
  const ruleValue = rule.value;

  const numberStatisticValue = Number(statisticValue);

  if (ValidationUtils.isInvalidNumberValue(statisticValue)) {
    // логируем не числовое значение
    const error = FrontendError.createParseNumberValueError(statistic.metricDesc, statisticValue);
    logError(error);

    return null;
  }

  const fracturedStatisticValue = statisticValue.split('.')[1];

  if (ruleValue !== 0 && fracturedStatisticValue && fracturedStatisticValue.length > ruleValue) {
    // логируем большое число знаков после запятой
    const error = FrontendError.createManySignsAfterCommaNumberValueError(statistic.metricDesc, statisticValue);

    if (shouldLogError) {
      logError(error);
    }

    statisticValue = numberStatisticValue.toFixed(ruleValue);
  }

  // исключаем округление чисел больше 1_000_000, чтобы число 1234567.89 отображалось в виде 1.23 млн.
  // а число 12345.67 отображалось в виде 12 345.67
  const transformedNumberStatisticValue = Number(statisticValue);

  if (transformedNumberStatisticValue >= MIN_HUGE_VALUE) {
    statisticValue = formatNumberSum(transformedNumberStatisticValue, {round: ruleValue});
  } else {
    statisticValue = formatNumberSum(transformedNumberStatisticValue);
  }

  return statisticValue;
};
